export default __webpack_public_path__ + "static/media/placeholder_business06-fr-mobile.d74dad90.png";